// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[5].use[1]!../../tailwind.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main-page {
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  background: #2e3440;
  padding: 5px;
  box-sizing: border-box;
  font-family: Verdana;
}
.btn-box {
  width: 100vw;
  height: 44px;
  border-bottom: 1px solid #000;
  /* background:linear-gradient(to bottom, #84bbcd 0, #666 100%); */
  display: flex;
  margin-bottom: 1px;
}
.tab-btn,
.tab-btn-active {
  font-size: var(--custom-font-size);
  /* width: 70px; */
  padding: 0 10px;
  height: 38px;
  line-height: 38px;
  border: 1px solid #000;
  cursor: pointer;
  margin-left: 5px;
  border-radius: 5px 5px 0 0;
  margin-top: 6px;
  color: #fff;
  text-align: center;
}
.tab-btn {
  background: #4a5467;
}
.tab-btn:hover {
  background: #84b9c8;
}
.tab-btn-active {
  /* background:linear-gradient(to bottom, #4a5467 0, #4a5467 100%); */
  background: #84b9c8;
  border-bottom: 1px solid #2e3440;
}
.header-box {
  position: relative;
}
.icon-user {
  position: absolute;
  color: #fff;
  top: 5px;
  right: 10px;
  cursor: pointer;
}
img {
  width: 30px;
  height: 30px;
}
`, "",{"version":3,"sources":["webpack://./../../ui/src/components/StudyListPage/StudyListPage.less"],"names":[],"mappings":"AACA;EACE,YAAA;EACA,aAAA;EACA,gBAAA;EACA,mBAAA;EACA,YAAA;EACA,sBAAA;EACA,oBAAA;AACF;AAEA;EACE,YAAA;EACA,YAAA;EACA,6BAAA;EAAA,iEAAiE;EAEjE,aAAA;EACA,kBAAA;AAAF;AAGA;;EACE,kCAAA;EAAA,iBAAiB;EAEjB,eAAA;EACA,YAAA;EACA,iBAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,0BAAA;EACA,eAAA;EACA,WAAA;EACA,kBAAA;AAAF;AAGA;EACE,mBAAA;AADF;AAIA;EACE,mBAAA;AAFF;AAKA;EAHE,oEAAoE;EAKpE,mBAAA;EACA,gCAAA;AAHF;AAMA;EACE,kBAAA;AAJF;AAOA;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,WAAA;EACA,eAAA;AALF;AAQA;EACE,WAAA;EACA,YAAA;AANF","sourcesContent":["@import url('../../tailwind.css');\n.main-page {\n  width: 100vw;\n  height: 100vh;\n  overflow: hidden;\n  background: #2e3440;\n  padding: 5px;\n  box-sizing: border-box;\n  font-family: Verdana;\n}\n\n.btn-box{\n  width: 100vw;\n  height: 44px;\n  border-bottom: 1px solid #000;\n  /* background:linear-gradient(to bottom, #84bbcd 0, #666 100%); */\n  display:flex;\n  margin-bottom:1px;\n}\n\n.tab-btn,.tab-btn-active{\n  font-size:var(--custom-font-size);\n  /* width: 70px; */\n  padding:0 10px;\n  height:38px;\n  line-height:38px;\n  border:1px solid #000;\n  cursor:pointer;\n  margin-left:5px;\n  border-radius:5px 5px 0 0;\n  margin-top:6px;\n  color:#fff;\n  text-align:center;\n}\n\n.tab-btn{\n  background:#4a5467;\n}\n\n.tab-btn:hover{\n  background:#84b9c8;\n}\n\n.tab-btn-active{\n  /* background:linear-gradient(to bottom, #4a5467 0, #4a5467 100%); */\n  background:#84b9c8;\n  border-bottom:1px solid #2e3440;\n}\n\n.header-box{\n  position: relative;\n}\n\n.icon-user{\n  position:absolute;\n  color:#fff;\n  top:5px;\n  right:10px;\n  cursor:pointer;\n}\n\nimg{\n  width:30px;\n  height:30px;\n}\n\n@primary-color: #1DA57A;@link-color: #1DA57A;@border-radius-base: 2px;"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
